var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSabeqoonIconColored13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.28 37.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1713"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.86,
    y: 1,
    width: 4.66,
    height: 4.66,
    fill: "#eb1470",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.14,9.77c-5.81,0-10.53,4.71-10.53,10.53s4.71,10.53,10.53,10.53,10.53-4.71,10.53-10.53-4.71-10.53-10.53-10.53ZM22.14,25.56c-2.91,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26,5.26,2.36,5.26,5.26-2.36,5.26-5.26,5.26Z",
    fill: "#fcb814",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1725"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.14,31.82c-6.36,0-11.53-5.17-11.53-11.53s5.17-11.53,11.53-11.53,11.53,5.17,11.53,11.53-5.17,11.53-11.53,11.53ZM22.14,10.77c-5.25,0-9.53,4.27-9.53,9.53s4.27,9.53,9.53,9.53,9.53-4.27,9.53-9.53-4.27-9.53-9.53-9.53Z",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1729"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.14,26.56c-3.45,0-6.26-2.81-6.26-6.26s2.81-6.26,6.26-6.26,6.26,2.81,6.26,6.26-2.81,6.26-6.26,6.26ZM22.14,16.04c-2.35,0-4.26,1.91-4.26,4.26s1.91,4.26,4.26,4.26,4.26-1.91,4.26-4.26-1.91-4.26-4.26-4.26Z",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1733"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.77,37.09H4.51c-2.49,0-4.51-2.02-4.51-4.51V9.77c0-2.49,2.02-4.51,4.51-4.51h9.02l.93-2.78c.5-1.49,1.88-2.48,3.45-2.48h8.49c1.57,0,2.95,1,3.45,2.48l.93,2.78h9.02c2.49,0,4.51,2.02,4.51,4.51v22.81c0,2.49-2.02,4.51-4.51,4.51ZM4.51,7.26c-1.38,0-2.51,1.13-2.51,2.51v22.81c0,1.38,1.13,2.51,2.51,2.51h35.26c1.38,0,2.51-1.13,2.51-2.51V9.77c0-1.38-1.13-2.51-2.51-2.51h-9.74c-.43,0-.81-.28-.95-.68l-1.15-3.46c-.22-.67-.84-1.12-1.55-1.12h-8.49c-.7,0-1.33.45-1.55,1.12l-1.15,3.46c-.14.41-.52.68-.95.68H4.51Z",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1737"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86,7.26h-5.26c-.55,0-1-.45-1-1v-3.51c0-1.52,1.24-2.75,2.75-2.75h1.75c1.52,0,2.75,1.24,2.75,2.75v3.51c0,.55-.45,1-1,1ZM5.6,5.26h3.26v-2.51c0-.42-.34-.75-.75-.75h-1.75c-.42,0-.75.34-.75.75v2.51Z",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1741"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.25,11.53c0,.73-.59,1.32-1.32,1.32s-1.32-.59-1.32-1.32.59-1.32,1.32-1.32,1.32.59,1.32,1.32",
    fill: "#000",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1745"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98,12.53h-2.63c-.55,0-1-.45-1-1s.45-1,1-1h2.63c.55,0,1,.45,1,1s-.45,1-1,1Z",
    fill: "#000",
    strokeWidth: 0
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabeqoonIconColored13);
export default __webpack_public_path__ + "static/media/Sabeqoon_Icon_Colored_13.c80233732e3c523c9ada2d4501391dae.svg";
export { ForwardRef as ReactComponent };